import React from 'react'

export default function ProductsKitchen() {
  return (
    <div>
      
    </div>
  )
}
